import { render, staticRenderFns } from "./WatchNowButtonNew.vue?vue&type=template&id=164b66c5"
import script from "./WatchNowButtonNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchNowButtonNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WatchNowButtonNew.vue?vue&type=style&index=0&id=164b66c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports